import { Component, Host, Input, OnInit, Optional, SkipSelf } from "@angular/core";
import { AbstractControl, ControlContainer, FormGroupDirective } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { mergeDeep } from "@bbwt/utils";

@Component({
    selector: "control-errors",
    template: `
        <div class="p-error" *ngIf="_control?.invalid && _control.touched">
            <ng-container *ngFor="let error of controlErrors">
                <small [style.display]="'block'" [innerHtml]="getErrorMessage(error)"></small>
            </ng-container>
        </div>
    `
})
export class ControlErrorsComponent implements OnInit {
    protected _control: AbstractControl = {} as any;

    @Input() control: AbstractControl | string;
    @Input() set errors(errors: { [key: string]: string }) {
        if (errors != null) {
            this.errorMessages = mergeDeep(this.errorMessages, errors);
        }
    }

    private errorMessages: { [key: string]: string } = {
        required: "This field is required",
        whitespace: "This field cannot be empty or whitespace",
        pattern: "This field is invalid",
        maxlength: "This field cannot have more than {requiredLength} characters",
        localMaxLength: "The email is not allowed to have more than {localMaxLength} characters before the @",
        domainMaxLength: "The email is not allowed to have more than {domainMaxLength} characters after the @",
        emailMaxLength: "The email is not allowed to have more than {emailMaxLength} characters",
        invalidDate: "The selected date is invalid",
        min: "The value cannot be less than {min}",
        max: "The value cannot be greater than {max}",
        _default: "This field has errors"
    };

    get controlErrors() {
        return Object.keys(this._control?.errors ?? {});
    }

    getErrorMessage(errorKey: string) {
        let errorMessage = this.errorMessages[errorKey] ?? this.errorMessages._default;

        const errorObj = this._control.errors[errorKey];
        for (const propertyName in errorObj) {
            errorMessage = errorMessage.replace(`{${propertyName}}`, errorObj[propertyName]);
        }

        return this.domSanitizer.bypassSecurityTrustHtml(errorMessage);
    }

    constructor(private domSanitizer: DomSanitizer, @Optional() @SkipSelf() @Host() private container: ControlContainer) {}

    ngOnInit() {
        if (typeof this.control === "string") {
            if (this.container instanceof FormGroupDirective) {
                this._control = this.container.control.get(this.control);
                if (this._control == undefined) {
                    throw new Error("Control name not found in parent control container");
                }
            }
        } else {
            this._control = this.control;
        }
    }
}
